const _temp0 = require("url:../assets/sounds/4-lines.mp3");
const _temp1 = require("url:../assets/sounds/game-over.mp3");
const _temp2 = require("url:../assets/sounds/landed.mp3");
const _temp3 = require("url:../assets/sounds/line-clear.mp3");
const _temp4 = require("url:../assets/sounds/move.mp3");
const _temp5 = require("url:../assets/sounds/rotate.mp3");
const _temp6 = require("url:../assets/sounds/theme.mp3");
module.exports = {
  "4-lines": _temp0,
  "game-over": _temp1,
  "landed": _temp2,
  "line-clear": _temp3,
  "move": _temp4,
  "rotate": _temp5,
  "theme": _temp6
}